module.exports = __webpack_public_path__ + "static/img/vote-05.f3b593a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vote/vote-05.png
// module id = 4iyK
// module chunks = 1